import { APIAdapter } from "../../../helpers/api_helper";

const api = new APIAdapter();

  export const createCompany = async (merchantId,data) => {
      try {
        const response = await api.create(`/merchants/${merchantId}/companies`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateCompany = async ( merchantId,companyId, data) => {
      try {
        const response = await api.put(`/merchants/${merchantId}/companies/${companyId}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const completeCompany = async (data) => {
      try {
        const response = await api.create(`/merchants/${data?.merchandId}/companies/${data?.companyId}/kyc`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getCompaniesByMarchandId = async (merchantId) => {
      try {
        const response = await api.get(`/merchants/${merchantId}/companies`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getAllCompanies = async () => {
      try {
        const response = await api.get(`/company-accounts`);
        return response;
      } catch (error) {
        throw error;
      }
  };


  export const deleteCompany = async (merchantId, companyId) => {
    try {
        const response = await api.delete(`/merchants/${merchantId}/companies/${companyId}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
